import { render, staticRenderFns } from "./DialogRevision.vue?vue&type=template&id=0ec45030&"
import script from "./DialogRevision.vue?vue&type=script&lang=js&"
export * from "./DialogRevision.vue?vue&type=script&lang=js&"
import style0 from "./DialogRevision.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports